import { setDefaultTitleTag } from "@faire/retailer-visitor-shared/components/App/DefaultTitleTags";
import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { useAssignSettingCheqAIImpactTest } from "@faire/retailer-visitor-shared/settings/useAssignSettingCheqAIImpactTest";
import { useAssignSettingDecentralizePageData } from "@faire/retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useAssignSettingNextJSRouterCache } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRouterCache";
import { useInitializeLocalization } from "@faire/signup/useInitializeLocalization";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import useMemoryMonitor from "@faire/web--source/common/performance/trackMemoryUsage";
import { useAdblockDetector } from "@faire/web--source/ui/AdblockDetector";
import { trackSessionsViewportRetailerPageViewView } from "@faire/web-api--source/events/sessions/view/viewportRetailerPageView";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const AppEffects = () => {
  const { strictLocalize } = useStrictLocalization();
  const { pathname } = useLocation();
  const { token: userToken } = getUser() ?? {};
  const assignSettingNextJSRouterCache = useAssignSettingNextJSRouterCache();
  const assignSettingCheqAIImpactTest = useAssignSettingCheqAIImpactTest();
  const assignSettingDecentralizePageData =
    useAssignSettingDecentralizePageData();

  useEffect(() => {
    assignSettingNextJSRouterCache();
  }, [assignSettingNextJSRouterCache]);

  useEffect(() => {
    assignSettingDecentralizePageData();
  }, [assignSettingDecentralizePageData]);

  useAdblockDetector(userToken);

  useInitializeLocalization();

  useEffect(() => {
    setDefaultTitleTag(strictLocalize);
  }, [strictLocalize]);

  useEffect(() => {
    assignSettingCheqAIImpactTest();
  }, [assignSettingCheqAIImpactTest]);

  /** Log viewport on path changge. */
  useEffect(() => {
    trackSessionsViewportRetailerPageViewView(
      pathname,
      `${getWindowOrThrow().innerWidth}`,
      `${getWindowOrThrow().innerHeight}`
    );
  }, [pathname]);

  useMemoryMonitor("web-retailer");

  return null;
};
